import { render, staticRenderFns } from "./QuirofanoPaqueteoperes.vue?vue&type=template&id=e026b24a&"
import script from "./QuirofanoPaqueteoperes.vue?vue&type=script&lang=js&"
export * from "./QuirofanoPaqueteoperes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports